import { ReactElement, useMemo, useRef, useState } from 'react';

import { JDSBreadcrumbsProps } from './generated';
import { LinkProps } from '../jdslink/logic';
import { setPositions } from '../jdsmenublock/positions';
import { useRootRef } from '../../hooks/useRootRef';

export interface LinkItem {
  title: string;
  href?: string;
  onClick?: React.MouseEventHandler;
  provider?: JSX.Element;
}

export interface BreadcrumbProps
  extends Pick<JDSBreadcrumbsProps, 'custom' | 'currentPage'> {
  currentPage: string;
  children?: ReactElement<LinkItem>[];
  links?: LinkProps[];
}

export const withLogic =
  (
    Component: React.ComponentType<BreadcrumbProps>
  ): React.FC<BreadcrumbProps> =>
  (props: BreadcrumbProps) => {
    const { children: links = [], links: linksArray } = props;
    const { element, rootRef } = useRootRef();

    const [open, setOpen] = useState(false);

    const truncatedRef = useRef(false);

    const [position, setPosition] = useState({ x: 0, y: 0, height: 0 });

    const allowedLinkIndices = useMemo(
      () => [0, null, links.length - 1 || linksArray?.length - 1 || 0],
      [links]
    );

    const hiddenLinks = links
      .map((l, i) => {
        if (!allowedLinkIndices.includes(i)) {
          return {
            label: l.props?.title || linksArray?.[i]?.title
          };
        }
        return null;
      })
      .filter((i) => !!i);

    const getShownLinks = useMemo(() => {
      if (
        (element?.offsetWidth && element.offsetWidth > window.innerWidth / 2) ||
        truncatedRef.current
      ) {
        truncatedRef.current = true;
        return allowedLinkIndices.map((index, i) => {
          if (i === 1) {
            return {
              title: '...',
              onClick: (ev: React.MouseEvent<HTMLDivElement>) => {
                setOpen(true);
                const { target } = ev;

                const { left, top, height } = setPositions(
                  target as HTMLDivElement,
                  undefined
                );
                setPosition({ x: left, y: top, height });
              }
            };
          }
          return links[index]?.props || linksArray?.[i];
        });
      } else if (!truncatedRef.current) {
        truncatedRef.current = false;
        return linksArray || links.map((l) => l.props);
      }
    }, [element, links, allowedLinkIndices]);
    console.log('currentPage', props.currentPage);

    return (
      <Component
        {...{
          ...props,
          hiddenLinks,
          shownLinks: getShownLinks,
          rootRef,
          open,
          _offsetX: position.x,
          _offsetY: position.y,
          _maxHeight: position.height,
          maxWidth: 'fit-content',
          onClose: () => setOpen(false),
          children: null
        }}
      />
    );
  };
